module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"per_observation_probability":"Per observation probability","probability":"Probability"},"fr":{"per_observation_probability":"Probabilité par observation","probability":"Probabilité"}}')
  delete Component.options._Ctor
}
